var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowblog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16.25C4.22707 16.25 0.75 12.7729 0.75 8.5C0.75 4.22707 4.22707 0.75 8.5 0.75C12.7729 0.75 16.25 4.22707 16.25 8.5C16.25 12.7729 12.7729 16.25 8.5 16.25Z",
    stroke: "#A71720",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17192 10.8827L9.37015 11.1486C9.48561 11.3034 9.70469 11.3355 9.85966 11.2202L13.0849 8.82041C13.273 8.68046 13.273 8.39876 13.0849 8.25881L9.85966 5.85906C9.70469 5.74376 9.48561 5.77579 9.37015 5.93065L9.17192 6.1965C9.05629 6.35158 9.08838 6.57104 9.24357 6.68652L11.7341 8.53961L9.24357 10.3927C9.08838 10.5082 9.05629 10.7276 9.17192 10.8827Z",
    fill: "#A71720",
    stroke: "#A71720",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1231 7.98438H3.1C2.9067 7.98438 2.75 8.14108 2.75 8.33438V8.66578C2.75 8.85909 2.9067 9.01578 3.1 9.01578H12.1231C12.3164 9.01578 12.4731 8.85908 12.4731 8.66578V8.33437C12.4731 8.14108 12.3164 7.98438 12.1231 7.98438Z",
    fill: "#A71720",
    stroke: "#A71720",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowblog);
export default __webpack_public_path__ + "static/media/Arrowblog.a9a361e7a5426c60ce55c1044ff34cd6.svg";
export { ForwardRef as ReactComponent };